<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="left sink">
<em>With love and gratitude for my friends Julia, Niels, Agnieszka, Cornelia, HaJo, Verena, Andrea, Antonie, Neithardt, Kirsten, Sahar, Evgenjia, Jörg, and Martina. And, of course, for you, Otti.</em>
</p>
<div class="timebreak "> </div>
<p class="left ">
<em>And you, Poldi.</em>
</p>
<div class="timebreak "> </div>
<p class="left ">
<em>Namaste!</em>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?5752f368